import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '../../shared/Button';
import { Link } from 'react-router-dom';

import styles from '../LoginForm/LoginForm.scss';

class PasswordRecoveryForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      completed: false,
    };

    this.onEmailChange = this.onEmailChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();
    const { email } = this.state;
    const { onSubmit } = this.props;

    onSubmit(email)
      .then(() => {
        this.setState({
          completed: true,
        });
      })
  }

  onEmailChange(event) {
    this.setState({ email: event.target.value });
  }

  renderMessage() {
    return this.state.completed ?
      (<p className={styles.message}>If this email has an account associated with it, a password reset email has been sent. If you continue to have problems, please <a href='https://www.radonaway.com/radon-contact.php' className={styles.link}>contact us</a>.</p>) : null;
  }

  renderSubmitButton() {
    const { isLoading } = this.props;
    const { email } = this.state;
    return(
      <Button
        disabled={isLoading || !email}
        type='submit'
        className='btn btn-primary'>
        {(isLoading ? <i className='fa fa-spin fa-spinner' /> : 'SEND EMAIL')}
      </Button>
    );
  }

  renderForm() {
    return !this.state.completed ? (
      <div>
        <p>Forgot My Password</p>
        <div className="form-group input-group">
          <div className="input-group-prepend">
            <div className="input-group-text">
              <span className='fa fa-envelope' />
            </div>
          </div>
          <input
            type="email"
            className="form-control"
            placeholder="Email"
            value={this.state.email}
            onChange={this.onEmailChange}
          />
        </div>
        {this.renderSubmitButton()}
      </div>
    ): null;
  }

  render() {
    return (
      <form className={styles.loginForm} onSubmit={this.handleSubmit}>
        {this.renderForm()}
        {this.renderMessage()}
      </form>
    );
  }
}

PasswordRecoveryForm.propTypes = {
  isLoading: PropTypes.bool,
  errorMessage: PropTypes.string,
  onSubmit: PropTypes.func.isRequired
};

export default PasswordRecoveryForm;


// WEBPACK FOOTER //
// src/components/login/PasswordRecoveryForm/PasswordRecoveryForm.js